import Repository from '../../repositories/RepositoryFactory';
import axios from '@/plugins/axios';
const ccmImagingRepository = Repository.get('ccmImaging');

export default {
	namespaced: true,
	state: {
		ccmImagingByPatientId: [],
		ccmImaging: null,
		jobs: [],
	},
	mutations: {
		UPDATE_JOBS (state, payload) {
			const jobIndex = state.jobs.findIndex((job) => job.id === payload.id);
			if (jobIndex !== -1) {
				state.jobs[jobIndex] = payload;
			} else {
				state.jobs.unshift(payload);
			}
		},

		STORE_CCM_IMAGING_BY_PATIENT_ID (state, payload) {
			state.ccmImagingByPatientId = payload;
		},
		STORE_CCM_IMAGING (state, payload) {
			state.ccmImaging = payload;
		},
		REMOVE_CCM_IMAGING (state, id) {
			state.ccmImagingByPatientId = state.ccmImagingByPatientId.filter(
				(imaging) => imaging.id !== id,
			);
		},
	},
	actions: {
		async getAllCCMImagingByPatientId ({ commit }, patientId) {
			// eslint-disable-next-line no-useless-catch
			try {
				const response = await ccmImagingRepository.getAllCCMImagingByPatientId(
					patientId,
				);
				commit('STORE_CCM_IMAGING_BY_PATIENT_ID', response.data);
			} catch (error) {
				throw error;
			}
		},

		async getSingleCCMImagingByPatientId ({ commit }, request) {
			// eslint-disable-next-line no-useless-catch
			try {
				const response =
					await ccmImagingRepository.getSingleCCMImagingByPatientId(
						request.patientId,
						request.imagingId,
					);
				commit('STORE_CCM_IMAGING', response.data);
			} catch (error) {
				throw error;
			}
		},

		async getCCMImaging ({ commit }, request) {
			const payload = {
				id: new Date().getTime(),
				patientId: request.patientId,
				fileName: request.fileName,
				percentage: 0,
				status: 'downloading',
				direction: 'download',
				totalSize: 0,
				completedSize: 0,
			};
			// eslint-disable-next-line no-useless-catch
			try {
				const response = await axios
					.get(`/ccmimaging/${request.id}`, {
						responseType: 'blob',
						onDownloadProgress: function (progressEvent) {
							payload.totalSize = progressEvent.total;
							payload.completedSize = progressEvent.loaded;
							payload.percentage = Math.round(
								(progressEvent.loaded / progressEvent.total) * 100,
							);

							commit('UPDATE_JOBS', payload);
						},
					})
					.catch(function () {
						payload.status = 'failed';
						commit('UPDATE_JOBS', payload);
					});

				payload.status = 'completed';
				commit('UPDATE_JOBS', payload);
				return response.data;

				// const response = await ccmImagingRepository.getCCMImaging(id);
			} catch (error) {
				throw error;
			}
		},

		async addCCMImaging ({ commit }, request) {
			const payload = {
				id: new Date().getTime(),
				patientId: parseInt(request.get('PatientId')),
				fileName: request.get('File').name,
				percentage: 0,
				status: 'uploading',
				direction: 'upload',
				totalSize: request.get('File').size,
				completedSize: 0,
			};
			// eslint-disable-next-line no-useless-catch
			try {
				await axios
					.post('/ccmimaging', request, {
						onUploadProgress: function (progressEvent) {
							payload.percentage = parseInt(
								(progressEvent.loaded / progressEvent.total) * 100,
							);
							payload.completedSize = progressEvent.loaded;
							commit('UPDATE_JOBS', payload);
						},
					})
					.then(function () {
						payload.status = 'completed';
						commit('UPDATE_JOBS', payload);
						return true;
					})
					.catch(function () {
						payload.status = 'failed';
						commit('UPDATE_JOBS', payload);
					});
			} catch (error) {
				throw error;
			}
		},

		async deleteCCMImaging ({ commit }, id) {
			// eslint-disable-next-line no-useless-catch
			try {
				commit('REMOVE_CCM_IMAGING', id);
				return await ccmImagingRepository.deleteCCMImaging(id);
			} catch (error) {
				throw error;
			}
		},
	},
};
